import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import currencyFormat from 'utils/currencyFormat';
import './index.scss';

function RenderTooltip({ active, payload }) {
  if (!active || !payload || payload?.length === 0) return null;

  const finalPayload = payload?.[0];
  if (!finalPayload) {
    return null;
  }

  let amountValue = currencyFormat(finalPayload.value, true, true);
  amountValue = amountValue ? amountValue.replace('₹', '') : 0;

  return (
    <div className="custom-tooltip-top-merchant">
      <Typography.Text className="text-top-merchants-title">Transaction Amount</Typography.Text>
      <br />
      <Typography.Text className="text-top-merchants">{`Name: ${finalPayload.payload?.merchant_name}`}</Typography.Text>
      <br />
      <Typography.Text className="text-top-merchants">{`GTV: ${amountValue}`}</Typography.Text>
    </div>
  );
}

RenderTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number
    })
  )
};
RenderTooltip.defaultProps = {
  active: false,
  payload: []
};

export default RenderTooltip;
